export default __webpack_public_path__ + "static/media/VIII_Old_Black.2b85c921.png";